import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import useApiErrorHandler from "../useApiErrorHandler";
import RoutesService from "../../services/routes/RoutesService";
import {
  startLoadingRoutes,
  setAccessibleRoutes,
  clearAccessibleRoutes,
  setLoading,
} from "../../store/slices/routes/routesSlice";

/**
 * 🚀 useRoutes
 *
 * Hook centralizado para manejar la búsqueda y estado de rutas accesibles.
 * - Permite buscar rutas según texto ingresado (qry).
 * - Gestiona el estado global (rutas + isLoading).
 * - Usa Redux para sincronizar el estado del spinner.
 */
export const useRoutes = () => {
  const dispatch: AppDispatch = useDispatch();
  const { handle } = useApiErrorHandler();

  const { routes, isLoading } = useSelector((state: RootState) => state.routes);

  // ===================================================
  // 🔍 CONSULTAS
  // ===================================================

  /**
   * 🔹 Buscar rutas accesibles según texto (qry)
   */
  const searchAccessibleRoutes = async (qry: string) => {
    try {
      dispatch(startLoadingRoutes());
      const response = await RoutesService.searchAccessibleRoutes(qry);
      const { statusCode, data } = response;

      if (statusCode === 200 && Array.isArray(data)) {
        dispatch(setAccessibleRoutes(data));
      } else {
        dispatch(clearAccessibleRoutes());
      }
    } catch (error) {
      handle(error);
      dispatch(clearAccessibleRoutes());
    }
  };

  // ===================================================
  // ⚙️ CONTROL MANUAL DE CARGA
  // ===================================================

  /**
   * 🔹 Permite establecer manualmente el estado de carga
   * (ejemplo: activar loading mientras el usuario escribe)
   */
  const setIsLoading = (value: boolean) => {
    dispatch(setLoading(value));
  };

  // ===================================================
  // 🧹 UTILIDADES
  // ===================================================

  /** 🔹 Limpia todas las rutas cargadas */
  const clearRoutes = () => dispatch(clearAccessibleRoutes());

  // ===================================================
  // 📦 RETORNO
  // ===================================================

  return {
    routes,
    isLoading,
    searchAccessibleRoutes,
    clearRoutes,
    setIsLoading, // 👈 nueva utilidad para control manual
  };
};

export default useRoutes;
